import { render, staticRenderFns } from "./copydata.vue?vue&type=template&id=68daf9dd&"
import script from "./copydata.vue?vue&type=script&lang=js&"
export * from "./copydata.vue?vue&type=script&lang=js&"
import style0 from "./copydata.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copydata.vue"
export default component.exports